/**
 * Audience arm.
 *
 * Loaded in the head without defer: the arm has to be on <html> before first paint,
 * otherwise the wrong arm's content flashes before CSS can hide it.
 *
 * Resolution order: page lock > forced arm > ?arm= / #arm > saved preference > 'pro'.
 */
(function () {
    var root = document.documentElement;
    var KEY = 'oo.site.arm';

    var store = {
        get: function (key, fallback) {
            try {
                return localStorage.getItem(key) || fallback;
            } catch (e) {
                return fallback;
            }
        },
        set: function (key, value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {
                /* private browsing */
            }
        },
    };

    function armFromUrl() {
        var query = new URLSearchParams(location.search).get('arm');
        if (query === 'pro' || query === 'edu') { return query; }
        if (location.hash === '#pro' || location.hash === '#edu') { return location.hash.slice(1); }
        return null;
    }

    function setArm(arm, persist) {
        root.dataset.arm = arm;
        if (persist !== false) { store.set(KEY, arm); }
        if (window.__ooNet) { window.__ooNet.repaint(); }

        var buttons = document.querySelectorAll('[data-arm-set]');
        for (var i = 0; i < buttons.length; i++) {
            var button = buttons[i];
            var on = button.dataset.armSet === arm;
            if (button.hasAttribute('aria-selected')) {
                button.setAttribute('aria-selected', on ? 'true' : 'false');
            } else {
                button.setAttribute('aria-pressed', on ? 'true' : 'false');
            }
        }
    }

    // The paint-blocking part runs immediately; anything touching <body> waits for it.
    var urlArm = armFromUrl();
    var savedArm = store.get(KEY, null);
    root.dataset.arm = urlArm || savedArm || 'pro';

    function boot() {
        var lock = document.body.dataset.lockArm;

        if (lock) {
            var switches = document.querySelectorAll('.armsw');
            for (var i = 0; i < switches.length; i++) {
                var sw = switches[i];
                sw.classList.add('armsw--locked', 'armsw--lock');
                sw.setAttribute('aria-label', 'Audience for this page');
                var options = sw.querySelectorAll('[data-arm-set]');
                for (var k = 0; k < options.length; k++) {
                    if (options[k].dataset.armSet !== lock) { options[k].remove(); }
                    else {
                        options[k].setAttribute('tabindex', '-1');
                        options[k].disabled = true;
                    }
                }
            }
        }

        var resolved = lock || document.body.dataset.forceArm || urlArm || savedArm || 'pro';
        setArm(resolved, Boolean(!lock && savedArm));

        // First-visit prompt: homepage only, once, and never blocking.
        var askPreview = new URLSearchParams(location.search).get('ask') === '1';
        if (!lock && (askPreview || (!urlArm && !savedArm)) && document.body.dataset.theme === 'home') {
            root.setAttribute('data-arm-ask', '');
            var clear = function () {
                root.removeAttribute('data-arm-ask');
                document.removeEventListener('click', onPick);
            };
            var onPick = function (event) {
                if (event.target.closest('[data-arm-set]')) { clear(); }
            };
            document.addEventListener('click', onPick);
        }

        document.addEventListener('click', function (event) {
            var button = event.target.closest('[data-arm-set]');
            if (!button) { return; }

            setArm(button.dataset.armSet);

            if (button.dataset.goto) {
                location.href = button.dataset.goto;
                return;
            }

            if (button.dataset.armScroll) {
                var target = document.querySelector(button.dataset.armScroll);
                if (target) {
                    window.scrollTo({
                        top: target.getBoundingClientRect().top + window.scrollY - 90,
                        behavior: 'smooth',
                    });
                }
            }
        });

        // Homepage doors: the CTA on the already-selected door navigates.
        document.addEventListener(
            'click',
            function (event) {
                var go = event.target.closest('.homedoors .door .go');
                if (!go) { return; }
                var door = go.closest('.door');
                if (door.getAttribute('aria-selected') !== 'true') { return; }
                if (!door.dataset.doorHref) { return; }
                event.stopPropagation();
                location.href = door.dataset.doorHref;
            },
            true
        );
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
